import { CART_SUCESS, GROSS_AMOUNT, FINAL_ORDER_PRICE,COMPANY_NAME, SHOP_NAME } from './action-types';

export function cart(payload: any) {
    return {
        type: CART_SUCESS,
        payload,
    };
}

export function grossAmount(payload: any) {
    return {
        type: GROSS_AMOUNT,
        payload,
    };
}

export function finalOrderPrice(payload: any) {
    return {
        type: FINAL_ORDER_PRICE,
        payload,
    };
}

export function companyName(payload: any) {
    return {
        type: COMPANY_NAME,
        payload,
    };
}

export function shopName(payload: any) {
    return {
        type: SHOP_NAME,
        payload,
    };
}